import React from "react";
import PropTypes from "prop-types";

import DateFormatter from "shared/formatters/dates";

const FormattedDate = ({ date }) =>
  date ? DateFormatter.fromDB(date) : <span>&mdash;</span>;

FormattedDate.propTypes = {
  date: PropTypes.string
};

export default FormattedDate;
